import type { SxProps, Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system/styleFunctionSx';

export function mergeSx(
  firstSx?: SxProps<Theme>,
  secondSx?: SxProps<Theme>,
): (theme: Theme) => SystemStyleObject<Theme> {
  return (theme) => {
    const firstSxResult = typeof firstSx === 'function' ? firstSx(theme) : firstSx;
    const secondSxResult = typeof secondSx === 'function' ? secondSx(theme) : secondSx;

    return {
      ...firstSxResult,
      ...secondSxResult,
    };
  };
}
